<template>
    <WidgetList state="edit" />
</template>

<script>
import WidgetList from '@/components/Settings/Widgets/WidgetList'
export default {
    name: 'EditWidget',
    components:{
        WidgetList
    }
}
</script>